module.exports = __webpack_public_path__ + "img/car_19.21155cec.jpg";